import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreNotificationsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-notifications',
	path: '/jira/core/projects/:projectKey/settings/notifications',
	exact: true,
};
